// extracted by mini-css-extract-plugin
var _1 = "dUUFPoddra2l5u8lDdeb";
export { _1 as "root" }
